


























import {
	addHours, format, isValid, parse, setHours, setMinutes,
} from 'date-fns';
import moment from 'moment';
import Vue from 'vue';
import Component from 'vue-class-component';

const Setup = Vue.extend({
	name: 'FormInputTime',
	props: {
		currentDate: [Date, String],
		minDateTime: [Date, String],
		maxDateTime: [Date, String],
		now: Boolean,
		placeholder: String,
		value: [Date, String],
		openTime: [Date, String],
		closeTime: [Date, String],
		time_interval_adjustment: Boolean,
	},
	watch: {
		minimumTime(newValue) {
			if (newValue >= (this as any).model) {
				let [hours, minutes] = newValue.split(':');
				if (+minutes > 30) {
					hours = +hours + 1;
					if (hours > 23) {
						hours -= 24;
					}

					if (hours < 10) {
						hours = `0${hours}`;
					}
					minutes = '00';
				} else if (+minutes && +minutes < 30) {
					minutes = '30';
				}

				(this as FormInputTime).model = `${hours}:${minutes}`;
			}
		},
	},
});

@Component
export default class FormInputTime extends Setup {
	// Props
	public currentDate!: string;
	public minDateTime!: string;
	public maxDateTime!: string;
	public now!: boolean;
	public placeholder!: string;
	public value!: any;
	public openTime!: string;
	public closeTime!: string;
	public time_interval_adjustment!: boolean;

	public get isCurrentDay(): boolean {
		if (this.minTime && this.currentDate) {
			const currentDate = parse(this.currentDate);
			if (!isValid(currentDate)) {
				return false;
			}

			if (format(currentDate, 'YYYY DDD') === format(this.minTime, 'YYYY DDD')) {
				return true;
			}
		}

		return false;
	}

	public get timeBreakdown(): number {
		if (this.time_interval_adjustment) {
			return 24;
		}
		return 48;
	}

	public get listeners(): any {
		return {
			...this.$listeners,
			input: (event: any) => {
				this.model = event.target.value;
				this.$emit('input', event.target.value);
			},
			change: (event: any) => {
				this.model = event.target.value;
				this.$emit('input', event.target.value);
			},
		};
	}

	public get minTime(): Date|null {
		let date: Date;

		if (this.minDateTime) {
			date = parse(this.minDateTime);

			return isValid(date) ? date : null;
		}

		return null;
	}

	public get minimumTime(): string {
		if (this.isCurrentDay && this.minTime) {
			return format(this.minTime, 'HH:mm');
		}

		return '';
	}

	public get model() {
		return this.value;
	}

	public set model(value: any) {
		this.$emit('input', value);
	}

	public created() {
		if (this.now && !this.model) {
			this.$nextTick(() => {
				this.model = format(addHours(new Date(), 1), 'HH:00');
			});
		} else {
			this.model = this.value;
		}
	}

	public checkMinimumTime(timeValue: string): boolean {
		if (!this.minimumTime) {
			return false;
		}

		return +timeValue.replace(':', '') < +this.minimumTime.replace(':', '');
	}

	public formatOptions(n: number): { hours: number, minutes: number } {
		if (this.time_interval_adjustment) {
			const iteration = n - 1;
			const hours = iteration;
			const minutes = 0;

			return { hours, minutes };
		}
		const iteration = n - 1;
		const isEven = !((iteration % 2));
		const hours = (isEven ? iteration : (iteration - 1)) / 2;
		const minutes = isEven ? 0 : 30;

		return { hours, minutes };
	}

	public getValue(n: number): string {
		const date = new Date();
		const options = this.formatOptions(n);

		// Check the value of time_interval_adjustment
		if (this.time_interval_adjustment) {
			return format(setHours(date, options.hours), 'HH:00') as string; // Format only hours
		}
		return format(setHours(setMinutes(date, options.minutes), options.hours), 'HH:mm') as string; // Format hours and minutes
	}

	public getOption(n: number): string {
		const date = new Date();
		const options = this.formatOptions(n);
		if (this.time_interval_adjustment) {
			return format(setHours(date, options.hours), 'hh:00 a') as string; // Format only hours
		}
		return format(setHours(setMinutes(date, options.minutes), options.hours), 'hh:mm a') as string;
	}

	public checkIfOpen(n: number): boolean {
		const time = moment(this.getValue(n), 'HH:mm');
		const open = moment(this.openTime, 'HH:mm');
		const close = moment(this.closeTime, 'HH:mm');
		if (!open.isValid() || !close.isValid()) {
			return true;
		}
		if (close <= open) {
			return !time.isBetween(close, open);
		}

		return time.isBetween(open, close) || time.isSame(open) || time.isSame(close);
	}
}
